import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls whether to remove the market hub and replace it with the all brands page
 */
export const REPLACE_MARKET_HUB_WITH_ALL_BRANDS_PAGE_250324 =
  'REPLACE_MARKET_HUB_WITH_ALL_BRANDS_PAGE_250324' as SettingConst<
    'REPLACE_MARKET_HUB_WITH_ALL_BRANDS_PAGE_250324',
    boolean,
    'RETAILER'
  >;
